import React, { useState, useRef, useEffect } from "react";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import Label from "../Label/Label";
import HintLabel from "../HintLabel/HintLabel";
import ErrorLabelWithValue from "../ErrorLabelWithValue/ErrorLabelWithValue";
import InfoIcon from "../InfoIcon/InfoIcon";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import InputDescription from "../InputDescription/InputDescription";
import PendingFieldConfirmButton from "../PendingFieldConfirmButton/PendingFieldConfirmButton";
import "./rich-editor.scss";

const RichEditor = (props) => {
  const {
    label,
    placeholder,
    hintText,
    value,
    disabled,
    description,
    error,
    pending,
    isRequired,
    validations,
    className,
    onBlur,
  } = props;
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);

  return (
    <div className="input-field">
      <Label className={pending ? "pending-label" : ""}>{label}</Label>
      <div className={`input-field__wrapper tinymce ${className}`}>
        <div className="input-field__inner-wrapper">
          <div className="input-field__confirm-wrapper">
            <EditorContainer
              placeholder={placeholder}
              disabled={disabled}
              value={value}
              onBlur={onBlur}
            />
            {pending && value && (
              <PendingFieldConfirmButton onClick={() => onBlur(value)} />
            )}
          </div>
          {description && <InfoIcon onClick={handleToggle} active={show} />}
        </div>
        <ErrorLabelWithValue
          isRequired={isRequired}
          error={error}
          validations={validations}
        />
        {hintText && <HintLabel>{hintText}</HintLabel>}
        {description && show && <InputDescription>{description}</InputDescription>}
      </div>
    </div>
  );
};

const EditorContainer = (props) => {
  const editorRef = useRef(null);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const { placeholder, disabled, onBlur } = props;
  const handleEditorChange = (editorState) => {
    setEditorState(editorState);
  };

  const handleEditorBlur = () => {
    onBlur(editorRef.current.editor.editor.outerHTML);
  };

  useEffect(() => {
    setEditorState(
      EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(props.value))
      )
    );
  }, [props.value]);

  return (
    <div className="editor">
      <Editor
        ref={editorRef}
        editorState={editorState}
        placeholder={placeholder}
        readOnly={disabled}
        editorClassName={disabled ? "disabled" : "customEditor"}
        onEditorStateChange={handleEditorChange}
        onBlur={handleEditorBlur}
        toolbar={{
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
          image: {
            alt: { present: true, mandatory: true },
          },
        }}
      />
    </div>
  );
};

export default RichEditor;
